// Admin API client for company applications and user management
import axiosInstance from "@/auth/axiosWithInterceptor";
import {
  CompanyApplication,
  CompanyApplicationListResponse,
  CompanyApplicationFormData,
  AdminUserListResponse,
  AdminDecisionRequest,
  AdminUserRoleUpdate,
  AdminUserStatusUpdate,
} from "@/types/admin";

// Company Applications API
export async function listCompanyApplications(params: {
  status?: string;
  search?: string;
  sort?: string;
  order?: "asc" | "desc";
  page?: number;
  page_size?: number;
}): Promise<CompanyApplicationListResponse> {
  const response = await axiosInstance.get<CompanyApplicationListResponse>(
    "/admin/company-applications",
    { params }
  );
  return response.data;
}

export async function getCompanyApplication(id: number): Promise<CompanyApplication> {
  const response = await axiosInstance.get<CompanyApplication>(
    `/admin/company-applications/${id}`
  );
  return response.data;
}

export async function makeApplicationDecision(
  id: number,
  data: AdminDecisionRequest
): Promise<CompanyApplication> {
  const response = await axiosInstance.patch<CompanyApplication>(
    `/admin/company-applications/${id}/decision`,
    data
  );
  return response.data;
}

// User Management API
export async function listUsers(params: {
  search?: string;
  sort?: string;
  order?: "asc" | "desc";
  page?: number;
  page_size?: number;
}): Promise<AdminUserListResponse> {
  const response = await axiosInstance.get<AdminUserListResponse>(
    "/admin/users",
    { params }
  );
  return response.data;
}

export async function updateUserRole(
  userId: number,
  data: AdminUserRoleUpdate
): Promise<{ message: string; is_admin: boolean }> {
  const response = await axiosInstance.patch<{ message: string; is_admin: boolean }>(
    `/admin/users/${userId}/role`,
    data
  );
  return response.data;
}

export async function updateUserStatus(
  userId: number,
  data: AdminUserStatusUpdate
): Promise<{ message: string; user_status: string }> {
  const response = await axiosInstance.patch<{ message: string; user_status: string }>(
    `/admin/users/${userId}/status`,
    data
  );
  return response.data;
}

// User-facing company application API
export async function submitCompanyApplication(
  data: CompanyApplicationFormData
): Promise<CompanyApplication> {
  const response = await axiosInstance.post<CompanyApplication>(
    "/company/application",
    data
  );
  return response.data;
}

export async function getMyCompanyApplication(): Promise<CompanyApplication> {
  const response = await axiosInstance.get<CompanyApplication>(
    "/company/application"
  );
  return response.data;
}

export async function withdrawCompanyApplication(
  review_notes?: string
): Promise<CompanyApplication> {
  const response = await axiosInstance.patch<CompanyApplication>(
    "/company/application/withdraw",
    { review_notes }
  );
  return response.data;
}
